<template>
  <b-row>
    <b-col>
      <h6 class="compo-heading">{{ $t('5003.generic.generic') }}</h6>
    </b-col>
  </b-row>
  <div class="details-card">
    <b-row>
      <b-col lg="12" md="12" sm="12" cols="12" class="addcircle_field">
        <div class="field">
          <CustomDropDown v-model="Generic.GenericId" :items="GenericDropdown.Genericoption" @change="GenericOnChange"
            name="Generic Name" id="Generic Name" :rules="{ required: false }" :required-icon="false" :tabindex="21" />
        </div>
        <span class="add_circle" @click="FunctionRights(EntityIds.Generic, 'Generic')"><i class="pi pi-plus"></i></span>
      </b-col>
    </b-row>
  </div>
  <GenericModal v-model:trigger="DialogShow.Generic" v-if="DialogShow.Generic"
    @load="LoadGeneric(), (DialogShow.Generic = false)" @close="DialogShow.Generic = false"
    :OperationID="ObjOperationId" :EntityId="EntityIds.Generic" />
  <Toast />
</template>

<script lang="ts">
import { defineComponent, ref, reactive, toRefs, onMounted } from "vue";
import service from "../../Service/ItemMasService";
import CustomDropDown from "../../../../components/FormComponents/Dropdown.vue";
import GenericModal from "../../../../modules/Inventory/pages/Masters/Pharmacy/GenericMaster/GenericMasterCreation.vue";
import MastersService from "../../../../modules/Inventory/Service/MastersService";
import { checkPermission } from "../../../../modules/Inventory/Service/AccessControl";
import { useToast } from "primevue/usetoast";

export default defineComponent({
  components: {
    CustomDropDown,
    GenericModal
  },

  props: {
    value: Object,
  },

  methods: {},

  setup(props, { emit }) {
    let session: any = localStorage.getItem('UsersData')
    const toast = useToast();
    session = JSON.parse(session)
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);
    let Generic = reactive({
      GenericId: ref(),
    });
    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }
    let Rights = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });
    const copyRights = JSON.parse(JSON.stringify(Rights.value));
    let ObjOperationId = ref({
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
    });
    const copyObjOperationId = JSON.parse(JSON.stringify(ObjOperationId.value));
    let DialogShow = ref({
      Generic: false,

    })
    let EntityIds = ref({
      Generic: 121,

    })
    onMounted(() => {
      LoadGeneric();
      Object.assign(Generic, props.value);
      input();
    });

    function input() {
      emit("update:modelValue", Generic);
    }

    //Load Generic
    const GenericDropdown = ref({
      Genericid: null,
      Genericoption: [],
    });

    async function LoadGeneric() {
      debugger;
      try {
        const response = await service.Generic();

        GenericDropdown.value.Genericoption = response["result"]
          .filter((f) => f.IsActive == true && f.HospitalId == HospitalId
            //   && f.BranchId == BranchId
          )
          .map((item) => {
            item.name = item.GenericName;
            item.value = item.Id;
            return item;
          });
      } catch (error) {
        alert(error);
      }
      input();
    }

    //Generic On Change
    const GenericOnChange = (value: any, option: Selection) => {
      debugger;
      Generic.GenericId = value.value;
    };
    async function FunctionRights(EntityId, FieldType) {
      debugger;
      Object.assign(Rights.value, copyRights);
      Object.assign(ObjOperationId.value, copyObjOperationId);
      const response = await MastersService.CheckMenuRights(
        EntityId,
        rolesData.RoleId
      );
      console.log(response["result"]);

      for (let i = 0; i < response["result"].length; i++) {
        const operation = response["result"][i];
        if (operation.OperationName === "Create") {
          ObjOperationId.value.CreateId = operation.OperationID;
          Rights.value.Create = operation.IsActive;
        }
        else if (operation.OperationName === "Update") {
          ObjOperationId.value.UpdateId = operation.OperationID;
          Rights.value.Update = operation.IsActive;
        } else if (operation.OperationName === "Read") {
          ObjOperationId.value.ReadId = operation.OperationID;
          Rights.value.Read = operation.IsActive;
        } else if (operation.OperationName === "Delete") {
          ObjOperationId.value.DeleteId = operation.OperationID;
          Rights.value.Delete = operation.IsActive;
        }
      }
      let permissionResult: any = checkPermission(Rights, "Add");
      if (permissionResult.hasPermission) {
        DialogShow.value[FieldType] = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    return {
      GenericDropdown,
      Generic,
      input,
      LoadGeneric,
      GenericOnChange,
      ObjOperationId,
      EntityIds,
      DialogShow,
      FunctionRights,
    };
  },

  created() { },
});
</script>
